/**
 * Where to send somebody after they sign in.
 *
 * Two things were wrong with the old arrangement, and they are the same bug
 * seen from each end.
 *
 * 1. The admin gate in `routes.tsx` sent `next: '/admin'` as a constant. The
 *    gate sits on the PARENT admin route, so every admin page bounced through
 *    it, and every one of them arrived at the sign-in page having forgotten
 *    where it was going. A link to a purchase order, followed by somebody who
 *    was signed out, landed on the dashboard.
 * 2. The sign-in form then navigated to `next` without looking at it. A path
 *    that arrives in a query string is not a path until somebody checks.
 *
 * So the gate now sends the address it actually bounced, and this function is
 * the one place that decides whether a `next` may be used at all.
 *
 * The rule is: a single leading slash, and nothing that a URL parser can read
 * as a host. `//evil.example` and `/\evil.example` are both absolute URLs to
 * browsers, which is why neither is a path here.
 */
export const DEFAULT_NEXT = '/account';

export function internalNext(raw: string | undefined | null): string {
  if (!raw) return DEFAULT_NEXT;
  if (!raw.startsWith('/')) return DEFAULT_NEXT;
  // `//host` and `/\host` are authorities, not paths.
  if (raw.startsWith('//') || raw.startsWith('/\\')) return DEFAULT_NEXT;
  return raw;
}
